import { render, staticRenderFns } from "./savedjobs.vue?vue&type=template&id=c1d48096"
import script from "./savedjobs.vue?vue&type=script&lang=js"
export * from "./savedjobs.vue?vue&type=script&lang=js"
import style0 from "./savedjobs.vue?vue&type=style&index=0&id=c1d48096&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports